export class Logger {
  private static enabled: boolean = false;

  public static enable() {
    this.enabled = true;
  }

  public static disable() {
    this.enabled = false;
  }

  public static log(message?: any, ...optionalParams: any[]): void {
    if (typeof console === 'undefined') {
      return;
    }

    if (this.enabled) {
      console.log(message, ...optionalParams);
    }
  }

  public static error(message?: any, ...optionalParams: any[]): void {
    if (typeof console === 'undefined') {
      return;
    }

    if (this.enabled) {
      console.error(message, ...optionalParams);
    }
  }

  public static warn(message?: any, ...optionalParams: any[]): void {
    if (typeof console === 'undefined') {
      return;
    }

    if (this.enabled) {
      console.warn(message, ...optionalParams);
    }
  }

  public static debug(message?: any, ...optionalParams: any[]): void {
    if (typeof console === 'undefined') {
      return;
    }

    if (this.enabled) {
      console.debug(message, ...optionalParams);
    }
  }
}
